/**
 * sb-abo-cart-total.js  (v4)
 *
 * Korrigiert die Summe im Summary von Discount On Cart Pro bei
 * Abo-Warenkoerben. Die App rechnet eine eigene Versandschaetzung ein und
 * kennt die automatische Shopify-Rabattregel "Kostenloser Versand bei
 * Abonnement" nicht (Bedingung "Cart has a selling plan", also some(),
 * keine Laenderbedingung). Discount Functions laufen erst im Checkout.
 *
 * ---------------------------------------------------------------------------
 * NICHT DEPLOYEN, solange offen ist, ob der Checkout bei aktivem Order- oder
 * Product-Discount ueberhaupt Gratisversand gewaehrt. In der Rabattregel sind
 * unter "Combinations" beide Haken leer. Faellt die Versandregel bei einem
 * Affiliate-Code durch, ist der von der App angezeigte Betrag INKLUSIVE
 * Versand korrekt und dieser Patch zeigt eine zu niedrige Summe an.
 * Referenzfall: 49,90 abzgl. 9,98 (FAIR-LIISAWOOD20)
 *   Checkout 39,92  -> dieser Patch ist richtig
 *   Checkout 44,87  -> Patch nicht einsetzen, stattdessen "Order discounts"
 *                      in der Rabattregel aktivieren
 * ---------------------------------------------------------------------------
 *
 * Einbindung in theme.liquid, vor </body>:
 *   <script src="{{ 'sb-abo-cart-total.js' | asset_url }}" defer></script>
 *
 * Bewusst externes Asset, nicht inline in einer Section: Nach einem Update
 * ueber die Section Rendering API fuegt das Theme HTML per innerHTML ein, und
 * darin enthaltene <script>-Tags fuehrt der Browser nicht aus. Daran ist der
 * frueher in mini-cart.liquid eingebettete Patch gescheitert - er lief beim
 * Reload, aber nie nach cart/add.
 *
 * Rechenweg (v4)
 *   Die App bildet:  est-total = (Zwischensumme - Rabatte) + Versandschaetzung
 *   Belegt durch die Promo-Zeile: 75,00 - 39,92 = 35,08, exakt der dort
 *   genannte Restbetrag. Die App kennt den rabattierten Warenwert also korrekt.
 *
 *   Dieser Patch rechnet daher  Zwischensumme - Summe(Rabattzeilen)
 *   und NICHT  angezeigte Summe - Versand. Der Unterschied ist Idempotenz:
 *   die Quellzeilen werden nie geschrieben, also kann sich der Wert bei
 *   wiederholten Observer-Durchlaeufen nicht weiter reduzieren.
 *
 *   v3 spiegelte stattdessen die Zwischensumme. Das war bei aktivem
 *   Rabattcode falsch (ignorierte den Rabatt) und traf zudem den falschen
 *   Knoten, weil die Summenzeile mit Rabatt zwei .money-Spans hat und der
 *   erste der durchgestrichene Ursprungspreis ist.
 *
 * Achtung: Abo-Erkennung prueft selling_plan_allocation, NICHT
 * recurring_deliveries wie abo_only_cart in den Sections. Prepaid-Plans haben
 * recurring_deliveries = false und wuerden sonst durchfallen.
 *
 * Pflaster. Entfaellt, sobald in Discount On Cart Pro die Versandschaetzung
 * abgeschaltet ist (Wrapper .docapp-with-shipping deutet auf ein Setting).
 */
(function () {
  'use strict';

  var SUMMARY = '.docapp-cart-with-coupon-summary';
  var ROWS = '.docapp-cart-with-coupon-summary--summary > .docapp-cart-item';

  var ROW_SUBTOTAL = 'docapp-cart-subtotal';
  var ROW_DISCOUNT = 'docapp-cart-discount';
  var ROW_TOTAL = 'docapp-est-total';

  // Zeilen ohne Einfluss auf den Warenwert. Alles, was hier NICHT steht und
  // einen Betrag enthaelt, fuehrt zum Abbruch - besser keine Korrektur als
  // eine stillschweigend falsche.
  var ROW_IGNORE = [
    'docapp-est-shipping-cost',
    'docapp-free-shipping-promo',
    'docapp-est-total',
    'docapp-affirm-cart',
    'docapp-paybright-cart',
    'docapp-cart-tax'
  ];

  var CART_TTL_MS = 800;

  var isSubCart = null; // null = unbekannt, dann nichts anfassen
  var lastFetchAt = 0;
  var rafQueued = false;
  var trailing = null;
  var warned = false;

  // Nur EUR. Bei aktiver Waehrungsumschaltung (Geolizr / BUCKS) waere das
  // Parsen und Neuformatieren von Betraegen nicht verlaesslich.
  function isEUR() {
    try {
      return !window.Shopify || !Shopify.currency || Shopify.currency.active === 'EUR';
    } catch (e) {
      return true;
    }
  }

  // "1.234,56 €" -> 123456
  function parseCents(text) {
    if (!text) return null;
    var m = String(text).replace(/\s/g, '').match(/(\d{1,3}(?:\.\d{3})*|\d+),(\d{2})/);
    if (!m) return null;
    return parseInt(m[1].replace(/\./g, ''), 10) * 100 + parseInt(m[2], 10);
  }

  function fmtEUR(cents) {
    var s = (cents / 100).toFixed(2).split('.');
    var whole = s[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return whole + ',' + s[1] + ' \u20AC';
  }

  function rowClass(row, name) {
    return row.classList.contains(name);
  }

  // Finaler Betrag der Summenzeile: letzter .money-Span, der NICHT im
  // durchgestrichenen Ursprungspreis liegt.
  function finalPriceEl(totalRow) {
    if (!totalRow) return null;
    var candidates = [].slice.call(totalRow.querySelectorAll('.money'))
      .filter(function (el) { return !el.closest('.docapp-line-through'); });
    return candidates.length ? candidates[candidates.length - 1] : null;
  }

  function amountOf(row) {
    var el = row.querySelector('.money');
    return el ? parseCents(el.textContent) : null;
  }

  // Reiner DOM-Schreibvorgang: kein fetch, keine Drosselung, idempotent.
  function apply() {
    if (isSubCart !== true || !isEUR()) return;

    var root = document.querySelector(SUMMARY);
    if (!root) return;

    var rows = [].slice.call(document.querySelectorAll(ROWS));
    if (!rows.length) return;

    var subtotal = null;
    var discounts = 0;

    for (var i = 0; i < rows.length; i++) {
      var row = rows[i];

      if (rowClass(row, ROW_SUBTOTAL)) {
        subtotal = amountOf(row);
        continue;
      }
      if (rowClass(row, ROW_DISCOUNT)) {
        var d = amountOf(row);
        if (d === null) return; // Rabattzeile ohne lesbaren Betrag
        discounts += d;
        continue;
      }

      var ignored = ROW_IGNORE.some(function (c) { return rowClass(row, c); });
      if (ignored) continue;

      // Unbekannte Zeile mit Betrag: Abbruch statt Ratespiel.
      if (row.querySelector('.money')) {
        if (!warned) {
          warned = true;
          console.warn('sb-abo-cart-total: unbekannte Summary-Zeile, keine Korrektur:', row.className);
        }
        return;
      }
    }

    if (subtotal === null) return;

    var correct = subtotal - discounts;
    if (correct < 0) return;

    var totalRow = document.querySelector('.' + ROW_TOTAL);
    var target = finalPriceEl(totalRow);
    if (!target) return;

    var text = fmtEUR(correct);
    if (target.textContent.trim() === text) return;

    target.textContent = text;
  }

  function refresh(force) {
    var now = Date.now();
    if (!force && now - lastFetchAt < CART_TTL_MS) return;
    lastFetchAt = now;

    fetch('/cart.js', {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin'
    })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        isSubCart = (cart.items || []).some(function (item) {
          return !!item.selling_plan_allocation;
        });
        apply();
      })
      .catch(function () {});
  }

  function onMutation() {
    if (!rafQueued) {
      rafQueued = true;
      requestAnimationFrame(function () { rafQueued = false; apply(); });
    }
    refresh(false);

    clearTimeout(trailing);
    trailing = setTimeout(function () { refresh(true); }, CART_TTL_MS + 200);
  }

  function boot() {
    refresh(true);

    try {
      new MutationObserver(onMutation).observe(document.body, {
        childList: true,
        subtree: true,
        characterData: true
      });
    } catch (e) {
      console.warn('sb-abo-cart-total:', e);
    }

    ['cart:updated', 'cart:refresh', 'cart:change'].forEach(function (evt) {
      document.addEventListener(evt, function () { refresh(true); });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();